'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { isProd } from 'enviro';
import httpNoAuth from 'hub-http/clients/noAuthApiClient';
import { formUrl } from 'self-service-api/core/utilities/links';
import { TRIAL_STATUS_TYPES } from './constants';
import HUBS from 'self-service-api/constants/Hubs';
import PortalIdParser from 'PortalIdParser';
import { MARKETING_PRO } from 'self-service-api/constants/UpgradeProducts';
import { getTrialGuideUrl, getReportsDashboardUrl } from '../utils/links.js';
export var getTrialModalUpgradeData = function getTrialModalUpgradeData(_ref) {
  var upgradeProduct = _ref.upgradeProduct,
      trialStatus = _ref.trialStatus;
  var uniqueId = trialStatus === TRIAL_STATUS_TYPES.EXPIRING_SOON ? 'expiring-soon-trial-modal' : 'expired-trial-modal';
  return {
    screen: 'index',
    uniqueId: uniqueId,
    app: 'reporting',
    upgradeProduct: upgradeProduct
  };
};
export var getSentenceCasedModalType = function getSentenceCasedModalType(trialStatus) {
  switch (trialStatus) {
    case TRIAL_STATUS_TYPES.EXPIRING_SOON:
      return 'expiring soon modal';

    case TRIAL_STATUS_TYPES.EXPIRED:
      return 'expired modal';

    default:
      return null;
  }
};
var PROD_TRIALS_SURVEY_FORM_ATTRIBUTE = {
  formId: '5a8ff44d-cba9-4502-8a52-822e4ddbf96a',
  portalId: '53'
};
var QA_TRIALS_SURVEY_FORM_ATTRIBUTE = {
  formId: '15dbddff-6e30-4a7a-91df-b591cb5fe2c8',
  portalId: '99609805'
};

var getTrialSurveyFormAttributes = function getTrialSurveyFormAttributes() {
  if (!isProd()) {
    return QA_TRIALS_SURVEY_FORM_ATTRIBUTE;
  }

  return PROD_TRIALS_SURVEY_FORM_ATTRIBUTE;
};

export var submitTrialSurvey = function submitTrialSurvey(data) {
  var formAttributes = getTrialSurveyFormAttributes();
  var formEndpoint = formUrl(formAttributes);

  if (!isProd()) {
    console.log('Submission to trial survey form', formEndpoint, data);
  }

  return httpNoAuth.post(formEndpoint, {
    data: data
  });
};
export var getTrialInstantActionRedirectUrl = function getTrialInstantActionRedirectUrl(hub) {
  var _hubToUrlPath;

  var hubToUrlPath = (_hubToUrlPath = {}, _defineProperty(_hubToUrlPath, HUBS.HUB_MARKETING, "/workflows/" + PortalIdParser.get() + "/platform/create/template?flowTypeId=0-1&scrollToElementId=scroll-to-new-action-config-0-1"), _defineProperty(_hubToUrlPath, HUBS.HUB_SALES, "/sequences/" + PortalIdParser.get() + "/create"), _hubToUrlPath);
  return hubToUrlPath[hub];
};
export var getAcademyTrialRedirectLink = function getAcademyTrialRedirectLink(upgradeProduct) {
  return upgradeProduct === MARKETING_PRO ? getTrialGuideUrl(upgradeProduct) : getReportsDashboardUrl();
};
export var getDemoPromptRedirectUrl = function getDemoPromptRedirectUrl(app) {
  var appToSource = {
    social: 'social-demo-prompt',
    seo: 'seo-demo-prompt',
    workflows: 'workflows-demo-prompt'
  };
  var appToDemoUrlPath = {
    social: "/trial-guide/" + PortalIdParser.get() + "/social-intro?flowId=social&source=" + appToSource[app],
    workflows: "/trial-guide/" + PortalIdParser.get() + "/reports-dashboard?flowId=nurture-qualify&source=" + appToSource[app],
    seo: "/trial-guide/" + PortalIdParser.get() + "/seo-intro?flowId=seo&source=" + appToSource[app]
  };
  return appToDemoUrlPath[app];
};